// FreeDeliveryPage.jsx
import React from 'react';
import "../../styles/sevicesPages/freeDeliveryPageStyle.css";
import deliveryImg from '../../assets/delivery.jpg';
import Navbar from '../../components/navbar';
import Footer from '../../components/footer';
import useScrollAnimation from '../../hooks/useScrollAnimation';
import { useNavigate } from 'react-router-dom';

const FreeDeliveryPage = () => {
    useScrollAnimation();

    const navigate = useNavigate();

  return (
    <>
    <Navbar/>
    <section className="free-delivery-page">
      {/* Hero Section */}
      <div className="hero-1" style={{ backgroundImage: `url(${deliveryImg})` }}>
        <div className="hero-overlay-1 slide-down">
          <h1 className='fade-in'>Free Prescription Delivery</h1>
          <p className='fade-in-delay'>We bring your medications to your doorstep, safely and quickly, at no extra cost.</p>
          <button className="cta-btn slide-up" onClick={() => navigate("/book-appointment")}>Request Delivery</button>
        </div>
      </div>

      {/* Benefits Section */}
      <div className="benefits">
        <h2 className='fade-in-delay-2'>Why Choose Our Delivery Service?</h2>
        <div className="benefits-cards slide-up-delay-1">
          <div className="card">
            <i className="fas fa-truck"></i>
            <h3>Fast & Reliable</h3>
            <p>Get your prescriptions delivered within 24-48 hours, directly to your home.</p>
          </div>
          <div className="card slide-up-delay-2">
            <i className="fas fa-shield-alt"></i>
            <h3>Safe & Secure</h3>
            <p>We handle your medications with care, ensuring safety and privacy.</p>
          </div>
          <div className="card slide-up-delay-3">
            <i className="fas fa-hand-holding-medical"></i>
            <h3>Convenient</h3>
            <p>No need to visit the pharmacy—save time and get your medicines from home.</p>
          </div>
        </div>
      </div>

      {/* Steps Section */}
      <div className="steps">
        <h2 className='fade-in-delay-2'>How It Works</h2>
        <div className="steps-cards">
          <div className="step-card step-1">
            <span>1</span>
            <h4>Upload Prescription</h4>
            <p>Send us a photo of your prescription online or in-store.</p>
          </div>
          <div className="step-card step-2">
            <span>2</span>
            <h4>Confirm Details</h4>
            <p>Our pharmacists verify your prescription and confirm your order.</p>
          </div>
          <div className="step-card step-3">
            <span>3</span>
            <h4>Delivery to Doorstep</h4>
            <p>Your medications are delivered safely and quickly to your home.</p>
          </div>
        </div>
      </div>

      {/* Call-to-action Section */}
      <div className="cta-section">
        <h2 className='fade-in-delay-3'>Get Your Prescriptions Delivered Today!</h2>
        <p className='fade-in-delay-3'>Enjoy the convenience of free delivery on all prescriptions. Stay healthy from the comfort of home.</p>
        <button className="cta-btn slide-up" onClick={() => navigate("/book-appointment")}>Request Delivery</button>
      </div>
    </section>
    <Footer/>
    </>
  );
};

export default FreeDeliveryPage;
